module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_chapel-72144da3818f667dd646c5bfd4abd747.jpg";